import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import InputAdornment from '@material-ui/core/InputAdornment';
import RenderPhoneField from '../../../../utils/renderFields/RenderPhoneField';
import RenderPinField from '../../../../utils/renderFields/RenderPinField';

import { updateUser } from '../../userProfileActions';
import { createPhoneCode } from '../../../signin/signinActions';
import bars from '../../../../img/bars.svg';

import validate from './validate';
import { Title, ActionLink, ConfirmationCodeTitle, CustomForm } from '../style';

/* eslint-disable import/no-mutable-exports */
let PhoneNumber = ({
  handleSubmit,
  createPhoneCodeSuccess,
  dispatchCreatePhoneCode,
  loading,
  phoneNumber
}) => (
  <div>
    <Title>Numéro de téléphone</Title>
    <Typography variant="subtitle2" gutterBottom>
      Modifier le numéro de téléphone associé à votre compte
    </Typography>
    <CustomForm onSubmit={handleSubmit} noValidate>
      <Grid container>
        <Grid item md={7}>
          <Field
            name="phoneNumber"
            id="phone-field"
            label="Numéro de téléphone"
            component={RenderPhoneField}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  style={{ position: 'relative', right: 5 }}
                >
                  {loading ? <img alt="loader" src={bars} width="20" /> : null}
                </InputAdornment>
              )
            }}
            autoFocus
            autoComplete="tel"
          />
        </Grid>
        <Grid item md={7}>
          {createPhoneCodeSuccess ? (
            <>
              <ConfirmationCodeTitle style={{ textAlign: 'center' }}>
                Code de confirmation
              </ConfirmationCodeTitle>
              <Field
                name="confirmationCode"
                id="confirmation-code"
                component={RenderPinField}
                autoFocus
                autoComplete="tel"
              />
              <ActionLink
                role="link"
                tabIndex="0"
                onClick={() =>
                  dispatchCreatePhoneCode(`${phoneNumber.replace(/\s/g, '')}`)
                }
              >
                Renvoyer le code
              </ActionLink>
            </>
          ) : (
            ''
          )}
        </Grid>
        <Grid item md={7}>
          <div style={{ textAlign: 'center' }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ marginTop: 60 }}
            >
              VALIDER
            </Button>
          </div>
        </Grid>
      </Grid>
    </CustomForm>
  </div>
);

const mapDispatchToProps = dispatch => ({
  dispatchCreatePhoneCode: phoneNumber => dispatch(createPhoneCode(phoneNumber))
});

const selector = formValueSelector('userPhoneNumber');
const mapStateToProps = state => ({
  currentUser: state.init.currentUser,
  createPhoneCodeSuccess: state.signin.createPhoneCodeSuccess,
  loading: state.signin.loading,
  callingCode: selector(state, 'callingCode'),
  phoneNumber: selector(state, 'phoneNumber'),
  initialValues: {
    phoneNumber: state.init.currentUser.phoneNumber
  }
});

PhoneNumber = reduxForm({
  form: 'userPhoneNumber',
  validate,
  onSubmit: (values, dispatch, props) => {
    const {
      company,
      email,
      firstname,
      lastname,
      parameters
    } = props.currentUser;
    const userInformations = {
      ...values,
      parameters,
      email,
      firstname,
      lastname,
      companyName: company ? company.name : '',
      companyRegistrationNumber: company ? company.registrationNumber : '',
      companyVatNumber: company ? company.vatNumber : ''
    };
    if (props.createPhoneCodeSuccess) {
      dispatch(updateUser(userInformations));
    } else {
      dispatch(createPhoneCode(values.phoneNumber));
    }
  }
})(PhoneNumber);

PhoneNumber.propTypes = {
  handleSubmit: PropTypes.func,
  phoneNumber: PropTypes.string,
  dispatchCreatePhoneCode: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  createPhoneCodeSuccess: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneNumber);
